import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { ContentObjectListDataObject } from 'models/service';

type ContentObjectsRequest = {
  community_id?: string;
  group_id?: string;
  pinned?: boolean;
  program_id?: string;
  program_topic_id?: string;
} & CursorPaginationRailsParams;

export const getContentObjects = async ({ config }: ConfigRequest<ContentObjectsRequest>) =>
  apiClient.get<ContentObjectListDataObject[], ApiClientResponse<ContentObjectListDataObject[]>>(
    routes.contentObjects.index,
    config,
  );
